export class ListRestoreJobsInternal200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<RestoreJob>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRestoreJobsInternal200Response.attributeTypeMap;
    }
    constructor() {
    }
}
